<template>
  <!-- TODO: make a dumb component -->
  <footer class="mpf-footer" role="contentinfo">
    <div v-if="!showFooterLinks" class="mpf-width-container">
      <div class="mpf-grid-row">
        <div class="mpf-u-margin-bottom-3 mpf-grid-column-one-half">
          <p class="mpf-body-s mpf-u-margin-bottom-1">Powered by</p>
          <span class="brand-logo brand-logo-medicus" aria-hidden="true"></span>
        </div>
        <div class="mpf-footer__meta mpf-grid-column-one-half">
          <p class="mpf-body-s mpf-u-margin-top-5 mpf-u-text-align-right">
            {{ tenantName }}
          </p>
        </div>
      </div>
    </div>
    <div v-else class="mpf-width-container">
      <div class="mpf-footer__meta">
        <h2 class="mpf-u-visually-hidden">Support links</h2>
        <ul class="mpf-footer__list">
          <li v-for="link in footerLinks" :key="link.path" class="mpf-footer__list-item">
            <component
              :is="link.href ? 'a' : 'router-link'"
              :href="link.href || null"
              :to="!link.href ? `${urlBase}/page/information/${link.path}` : null"
              class="mpf-footer__list-item-link"
              :target="openLinksInTab || link.href ? '_blank' : null"
              :rel="openLinksInTab || link.href ? 'noopener noreferrer' : null"
            >
              {{ link.text }}
            </component>
          </li>
        </ul>

        <p class="mpf-body-s">{{ footerText }}</p>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
  withDefaults(
    defineProps<{
      showFooterLinks: boolean;
      openLinksInTab: boolean;
      urlBase?: string;
      tenantName?: string;
      footerText?: string;
    }>(),
    {
      showFooterLinks: false,
      openLinksInTab: false,
    },
  );
  interface FooterLink {
    text: string;
    path: string;
    href?: string;
  }

  const footerLinks: FooterLink[] = [
    {
      text: 'Privacy notice',
      path: 'privacy-notice',
      href: 'https://medicus.health/privacy-notice/',
    },
    {
      text: 'Patient terms of use',
      path: 'patient-terms-of-use',
      href: 'https://medicus.health/patient-terms-of-use/',
    },
    {
      text: 'Accessibility statement',
      path: 'accessibility-statement',
      href: 'https://medicus.health/accessibility-statement/',
    },
    {
      text: 'Cookies policy',
      path: 'cookies-policy',
      href: 'https://medicus.health/cookies-policy/',
    },
  ];
</script>
